import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { getSessionDetails } from '../../services/main-service';
import { Link } from 'react-router-dom';
import { Modal, Spinner } from 'react-bootstrap';
import { logout } from "../../redux/actions/auth.action";
import { storage } from '../../utils/firebaseUtils';
import { getCustomerName } from "../../utils";

const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "July", "Aug", "Sep", "Oct", "Nov", "Dec"];

function Downloads(props: any) {
    const customerName = getCustomerName(props.user);
    const [selectedReportList, setSelectedReportList] = useState<any>([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        loadMonthlyReports();
    }, []);

    const loadMonthlyReports = async () => {
        setIsLoading(true);
        let isCookieAvailable: any = await getSessionDetails();
        if (!isCookieAvailable) {
            props.dispatch(logout());
            return;
        }

        const targetPath = `${customerName}/monthly-report`;
        const storageRef = storage.ref();
        const listRef = storageRef.child(targetPath);

        try {
            const res = await listRef.listAll();
            
            // Map items to record objects
            const listOfReports = res.items.map((itemRef) => ({
                fullPath: itemRef.fullPath,
                bucket: itemRef.bucket,
                name: itemRef.name,
                size: "",
                updated: ""
            }));

            if (listOfReports.length === 0) {
                setSelectedReportList([]);
                setIsLoading(false);
                return;
            }

            // Fetch metadata for all files concurrently
            const metadataPromises = listOfReports.map(async (record) => {
                const fileRef = storageRef.child(record.fullPath);
                const metadata = await fileRef.getMetadata();

                const t = new Date(metadata.timeCreated);
                const formattedDate = `${t.getDate()}/${MONTHS[t.getMonth()]}/${t.getFullYear()} ${('0' + t.getHours()).slice(-2)}:${('0' + t.getMinutes()).slice(-2)}:${('0' + t.getSeconds()).slice(-2)}`;

                return {
                    ...record,
                    size: formatBytes(metadata.size),
                    updated: formattedDate
                };
            });

            const resolvedReports = await Promise.all(metadataPromises);
            setSelectedReportList(resolvedReports);
        } catch (error) {
            console.error("Exception occurred while fetching monthly reports: ", error);
            setSelectedReportList([]);
        } finally {
            setIsLoading(false);
        }
    };

    const downloadReport = async (record: any) => {
        setIsLoading(true);
        const storageRef = storage.ref();
        const fileRef = storageRef.child(record.fullPath);

        try {
            const url = await fileRef.getDownloadURL();
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', record.name);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error: any) {
            console.error("EXCEPTION in downloadReport: ", error.code || error);
        } finally {
            setIsLoading(false);
        }
    };

    const formatBytes = (bytes: any, decimals = 2) => {
        if (bytes === 0) return '0 Bytes';
        const k = 1024;
        const dm = decimals < 0 ? 0 : decimals;
        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    };

    return (
        <div className="page-heading">
            <div className="page-title">
                <div className="row">
                    <div className="col-12 col-md-6 order-md-1 order-last">
                        <h3 className='vv-color-code'>Monthly Reports</h3>
                    </div>
                    <div className="col-12 col-md-6 order-md-2 order-first">
                        <nav aria-label="breadcrumb" className="breadcrumb-header float-start float-lg-end">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item"><Link to="/">Dashboard</Link></li>
                                <li className="breadcrumb-item active" aria-current="page">Downloads</li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>

            <section id="form-and-scrolling-components">
                <Modal show={isLoading} centered backdrop="static" keyboard={false}>
                    <Modal.Body> <Spinner animation="border" /> Loading... </Modal.Body>
                </Modal>
            </section>

            <div className='DownloadList'>
                <table id="downloadItems" style={{ width: "100%", minWidth: "100%" }}>
                    <thead style={{ width: "100%", minWidth: "100%" }} className="vv-color-code">
                        <tr style={{ width: "100%", minWidth: "100%" }}>
                            <th style={{ width: "40%" }}>File Name</th>
                            <th style={{ width: "40%" }}>Date Time</th>
                            <th style={{ width: "20%" }}>Size</th>
                        </tr>
                    </thead>
                    <tbody>
                        {selectedReportList.length > 0 ? (
                            selectedReportList.map((rec: any, idx: number) => (
                                <tr key={rec.fullPath || idx}>
                                    <td>
                                        <a href='#' onClick={(e) => { e.preventDefault(); downloadReport(rec); }} title='Click to download'>
                                            {rec.name}
                                        </a>
                                    </td>
                                    <td>{rec.updated}</td>
                                    <td>{rec.size}</td>
                                </tr>
                            ))
                        ) : (
                            !isLoading && (
                                <tr>
                                    <td colSpan={3} style={{ textAlign: 'center', padding: '1rem' }}>
                                        No monthly reports found.
                                    </td>
                                </tr>
                            )
                        )}
                    </tbody>
                </table>
            </div>            
        </div>
    );
}

function mapStateToProps(state: any) {
    const { isLoggedIn } = state.client.isLoggedIn;
    const { message } = state.messages;
    return {
        isLoggedIn,
        user: state.client.user,
        message
    };
}

export default connect(mapStateToProps)(Downloads);
